module.exports = __webpack_public_path__ + "img/impressions_yishu.47c27e9f.png";